"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.US_STATES = exports.MONTH_VALUES = exports.COUNTRY_VALUES = exports.CANADIAN_PROVINCES = exports.PAYMENT_SAME_AS_BILLING = exports.CONTACT_NAME = exports.CONTACT_COMPANY = exports.CONTACT_ADDRESS = exports.CONTACT_STREET_ADDRESS = exports.SECURITY_CODE = exports.EXPIRATION_YEAR = exports.EXPIRATION_MONTH = exports.CARD_NUMBER = exports.CARD_NAME = exports.ACCEPTED_TERMS = exports.BILLING_STATE = exports.BILLING_POSTAL_CODE = exports.BILLING_COUNTRY = exports.BILLING_CITY = exports.BILLING_ADDRESS_2 = exports.BILLING_ADDRESS_1 = exports.ACCOUNT_STATE = exports.ACCOUNT_POSTAL_CODE = exports.ACCOUNT_LAST_NAME = exports.ACCOUNT_FIRST_NAME = exports.ACCOUNT_COUNTRY = exports.ACCOUNT_COMPANY = exports.ACCOUNT_CITY = exports.ACCOUNT_ADDRESS_2 = exports.ACCOUNT_ADDRESS_1 = void 0; // BILLING FORM CONSTANTS
// VERY IMPORTANT!!! TO BE VERY CAREFUL WHEN CHANGING THE BILLING FORM CONSTANTS
// CONSTANTS USED IN BILLING FORM, ACCOUNT DETAILS FORM AND ADDRESS FORM

var ACCOUNT_ADDRESS_1 = 'accountAddress1';
exports.ACCOUNT_ADDRESS_1 = ACCOUNT_ADDRESS_1;
var ACCOUNT_ADDRESS_2 = 'accountAddress2';
exports.ACCOUNT_ADDRESS_2 = ACCOUNT_ADDRESS_2;
var ACCOUNT_CITY = 'accountCity';
exports.ACCOUNT_CITY = ACCOUNT_CITY;
var ACCOUNT_COMPANY = 'company';
exports.ACCOUNT_COMPANY = ACCOUNT_COMPANY;
var ACCOUNT_COUNTRY = 'accountCountry';
exports.ACCOUNT_COUNTRY = ACCOUNT_COUNTRY;
var ACCOUNT_FIRST_NAME = 'firstName';
exports.ACCOUNT_FIRST_NAME = ACCOUNT_FIRST_NAME;
var ACCOUNT_LAST_NAME = 'lastName';
exports.ACCOUNT_LAST_NAME = ACCOUNT_LAST_NAME;
var ACCOUNT_POSTAL_CODE = 'accountPostalCode';
exports.ACCOUNT_POSTAL_CODE = ACCOUNT_POSTAL_CODE;
var ACCOUNT_STATE = 'accountState';
exports.ACCOUNT_STATE = ACCOUNT_STATE;
var BILLING_ADDRESS_1 = 'billingAddress1';
exports.BILLING_ADDRESS_1 = BILLING_ADDRESS_1;
var BILLING_ADDRESS_2 = 'billingAddress2';
exports.BILLING_ADDRESS_2 = BILLING_ADDRESS_2;
var BILLING_CITY = 'billingCity';
exports.BILLING_CITY = BILLING_CITY;
var BILLING_COUNTRY = 'billingCountry';
exports.BILLING_COUNTRY = BILLING_COUNTRY;
var BILLING_POSTAL_CODE = 'billingPostalCode';
exports.BILLING_POSTAL_CODE = BILLING_POSTAL_CODE;
var BILLING_STATE = 'billingstate';
exports.BILLING_STATE = BILLING_STATE;
var ACCEPTED_TERMS = 'acceptedTerms'; // field names for the credit card
// also used as keys for hidden zuora inputs

exports.ACCEPTED_TERMS = ACCEPTED_TERMS;
var CARD_NAME = 'field_creditCardHolderName';
exports.CARD_NAME = CARD_NAME;
var CARD_NUMBER = 'number';
exports.CARD_NUMBER = CARD_NUMBER;
var EXPIRATION_MONTH = 'creditCardExpirationMonth';
exports.EXPIRATION_MONTH = EXPIRATION_MONTH;
var EXPIRATION_YEAR = 'creditCardExpirationYear';
exports.EXPIRATION_YEAR = EXPIRATION_YEAR;
var SECURITY_CODE = 'creditCardSecurityCode'; // CONTACT NAME INFO PASS THROUGH FROM ZUORA

exports.SECURITY_CODE = SECURITY_CODE;
var CONTACT_STREET_ADDRESS = 'field_passthrough2';
exports.CONTACT_STREET_ADDRESS = CONTACT_STREET_ADDRESS;
var CONTACT_ADDRESS = 'field_passthrough5';
exports.CONTACT_ADDRESS = CONTACT_ADDRESS;
var CONTACT_COMPANY = 'field_passthrough3';
exports.CONTACT_COMPANY = CONTACT_COMPANY;
var CONTACT_NAME = 'field_passthrough1'; // SHOW SEPARATE BILLING ADDRESS FORM - mailing addr different from billing addr

exports.CONTACT_NAME = CONTACT_NAME;
var PAYMENT_SAME_AS_BILLING = 'showPaymentAddress';
exports.PAYMENT_SAME_AS_BILLING = PAYMENT_SAME_AS_BILLING;
var CANADIAN_PROVINCES = [{
  label: 'Alberta',
  value: 'Alberta'
}, {
  label: 'British Columbia',
  value: 'British Columbia'
}, {
  label: 'Manitoba',
  value: 'Manitoba'
}, {
  label: 'New Brunswick',
  value: 'New Brunswick'
}, {
  label: 'Newfoundland and Labrador',
  value: 'Newfoundland and Labrador'
}, {
  label: 'Nova Scotia',
  value: 'Nova Scotia'
}, {
  label: 'Ontario',
  value: 'Ontario'
}, {
  label: 'Prince Edward Island',
  value: 'Prince Edward Island'
}, {
  label: 'Quebec',
  value: 'Quebec'
}, {
  label: 'Saskatchewan',
  value: 'Saskatchewan'
}, {
  label: 'Northwest Territories',
  value: 'Northwest Territories'
}, {
  label: 'Nunavut',
  value: 'Nunavut'
}, {
  label: 'Yukon Territories',
  value: 'Yukon Territories'
}];
exports.CANADIAN_PROVINCES = CANADIAN_PROVINCES;
var COUNTRY_VALUES = [{
  label: 'United States',
  value: 'US'
}, {
  label: 'Canada',
  value: 'CA'
}];
exports.COUNTRY_VALUES = COUNTRY_VALUES;
var MONTH_VALUES = [{
  label: 'January',
  value: '1'
}, {
  value: '2',
  label: 'February'
}, {
  label: 'March',
  value: '3'
}, {
  label: 'April',
  value: '4'
}, {
  label: 'May',
  value: '5'
}, {
  label: 'June',
  value: '6'
}, {
  label: 'July',
  value: '7'
}, {
  label: 'August',
  value: '8'
}, {
  label: 'September',
  value: '9'
}, {
  label: 'October',
  value: '10'
}, {
  label: 'November',
  value: '11'
}, {
  label: 'December',
  value: '12'
}];
exports.MONTH_VALUES = MONTH_VALUES;
var US_STATES = [{
  label: 'Alabama',
  value: 'Alabama'
}, {
  label: 'Alaska',
  value: 'Alaska'
}, {
  label: 'Arizona',
  value: 'Arizona'
}, {
  label: 'Arkansas',
  value: 'Arkansas'
}, {
  label: 'California',
  value: 'California'
}, {
  label: 'Colorado',
  value: 'Colorado'
}, {
  label: 'Connecticut',
  value: 'Connecticut'
}, {
  label: 'Delaware',
  value: 'Delaware'
}, {
  label: 'Washington DC',
  value: 'Washington DC'
}, {
  label: 'Florida',
  value: 'Florida'
}, {
  label: 'Georgia',
  value: 'Georgia'
}, {
  label: 'Hawaii',
  value: 'Hawaii'
}, {
  label: 'Idaho',
  value: 'Idaho'
}, {
  label: 'Illinois',
  value: 'Illinois'
}, {
  label: 'Indiana',
  value: 'Indiana'
}, {
  label: 'Iowa',
  value: 'Iowa'
}, {
  label: 'Kansas',
  value: 'Kansas'
}, {
  label: 'Kentucky',
  value: 'Kentucky'
}, {
  label: 'Louisiana',
  value: 'Louisiana'
}, {
  label: 'Maine',
  value: 'Maine'
}, {
  label: 'Maryland',
  value: 'Maryland'
}, {
  label: 'Massachusetts',
  value: 'Massachusetts'
}, {
  label: 'Michigan',
  value: 'Michigan'
}, {
  label: 'Minnesota',
  value: 'Minnesota'
}, {
  label: 'Mississippi',
  value: 'Mississippi'
}, {
  label: 'Missouri',
  value: 'Missouri'
}, {
  label: 'Montana',
  value: 'Montana'
}, {
  label: 'Nebraska',
  value: 'Nebraska'
}, {
  label: 'Nevada',
  value: 'Nevada'
}, {
  label: 'New Hampshire',
  value: 'New Hampshire'
}, {
  label: 'New Jersey',
  value: 'New Jersey'
}, {
  label: 'New Mexico',
  value: 'New Mexico'
}, {
  label: 'New York',
  value: 'New York'
}, {
  label: 'North Carolina',
  value: 'North Carolina'
}, {
  label: 'North Dakota',
  value: 'North Dakota'
}, {
  label: 'Ohio',
  value: 'Ohio'
}, {
  label: 'Oklahoma',
  value: 'Oklahoma'
}, {
  label: 'Oregon',
  value: 'Oregon'
}, {
  label: 'Pennsylvania',
  value: 'Pennsylvania'
}, {
  label: 'Rhode Island',
  value: 'Rhode Island'
}, {
  label: 'South Carolina',
  value: 'South Carolina'
}, {
  label: 'South Dakota',
  value: 'South Dakota'
}, {
  label: 'Tennessee',
  value: 'Tennessee'
}, {
  label: 'Texas',
  value: 'Texas'
}, {
  label: 'Utah',
  value: 'Utah'
}, {
  label: 'Vermont',
  value: 'Vermont'
}, {
  label: 'Virginia',
  value: 'Virginia'
}, {
  label: 'Washington',
  value: 'Washington'
}, {
  label: 'West Virginia',
  value: 'West Virginia'
}, {
  label: 'Wisconsin',
  value: 'Wisconsin'
}, {
  label: 'Wyoming',
  value: 'Wyoming'
}];
exports.US_STATES = US_STATES;